/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  GetConfigurationsByScopeQueryResponse,
  GetConfigurationsByScopePathParams,
  GetConfigurationsByScopeQueryParams,
} from "../types/GetConfigurationsByScope.ts"

export const getConfigurationsByScopeQueryKey = (
  productSheetGroupId: GetConfigurationsByScopePathParams["productSheetGroupId"],
  params: GetConfigurationsByScopeQueryParams
) =>
  [
    {
      url: "/v1/organization-settings/get-configurations-by-scope/:productSheetGroupId",
      params: { productSheetGroupId },
    },
    ...(params ? [params] : []),
  ] as const

export type GetConfigurationsByScopeQueryKey = ReturnType<
  typeof getConfigurationsByScopeQueryKey
>

/**
 * @summary Get configurations by productSheetGroup and by scope
 * {@link /v1/organization-settings/get-configurations-by-scope/:productSheetGroupId}
 */
export async function getConfigurationsByScope(
  productSheetGroupId: GetConfigurationsByScopePathParams["productSheetGroupId"],
  params: GetConfigurationsByScopeQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetConfigurationsByScopeQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/organization-settings/get-configurations-by-scope/${productSheetGroupId}`,
    params,
    ...requestConfig,
  })
  return res
}

export function getConfigurationsByScopeQueryOptions(
  productSheetGroupId: GetConfigurationsByScopePathParams["productSheetGroupId"],
  params: GetConfigurationsByScopeQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getConfigurationsByScopeQueryKey(productSheetGroupId, params)
  return queryOptions<
    ResponseConfig<GetConfigurationsByScopeQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetConfigurationsByScopeQueryResponse>,
    typeof queryKey
  >({
    enabled: !!(productSheetGroupId && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getConfigurationsByScope(productSheetGroupId, params, config)
    },
  })
}

/**
 * @summary Get configurations by productSheetGroup and by scope
 * {@link /v1/organization-settings/get-configurations-by-scope/:productSheetGroupId}
 */
export function useGetConfigurationsByScope<
  TData = ResponseConfig<GetConfigurationsByScopeQueryResponse>,
  TQueryData = ResponseConfig<GetConfigurationsByScopeQueryResponse>,
  TQueryKey extends QueryKey = GetConfigurationsByScopeQueryKey,
>(
  productSheetGroupId: GetConfigurationsByScopePathParams["productSheetGroupId"],
  params: GetConfigurationsByScopeQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetConfigurationsByScopeQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ??
    getConfigurationsByScopeQueryKey(productSheetGroupId, params)

  const query = useQuery(
    {
      ...getConfigurationsByScopeQueryOptions(
        productSheetGroupId,
        params,
        config
      ),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
